import { formatDate } from '@angular/common';
import {
  IBulkCreateInvoiceColumn
} from '../../../../invoice/components/invoice-bulk-create-dialog/constants/invoice-bulk-create-dialog.constants';

const getTableColumnConfig = (): IBulkCreateInvoiceColumn<any>[] => {
  return [
    {
      key: 'orderDate',
      header: 'Order Date',
      formatter: (data) => formatDate(data.orderDate, 'mediumDate', 'en-US')
    },
    {
      key: 'id',
      header: 'Order ID'
    },
    {
      key: 'orderNumber',
      header: 'Order #'
    },
    {
      key: 'orderTotal',
      header: 'Total',
      formatter: (data) => data.orderTotal.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    },
  ];
};

export const FulfillmentOrdersGridBulkCreateInvoiceConfig = {
  getTableColumnConfig,
};
